module.exports = __webpack_public_path__ + "static/media/dumbbell.89928ab4.svg";